import { Component } from 'react';
import './Loader.scss';

export class Loader extends Component {
    public render() {
        return <div className="preloader" >
            <div className="preloader-spinner">
                <div className="bounce1" />
                <div className="bounce2" />
            </div>
        </div>
    }
}